import { addHeader } from './addHeader';

export const makeRequest = async (url: string, init: RequestInit = {}) => fetch(url, addHeader(init));
